module.exports = __webpack_public_path__ + "static/media/model_certificate.c8342e0d.png";